<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  header="Modifier l'événement"
  [style]="{ width: '700px', maxHeight: '90vh' }"
  (onHide)="hide()"
  styleClass="compact-modal"
>
  <div class="p-fluid">
    <div *ngIf="selectedEvent">
      <form [formGroup]="form" (ngSubmit)="updateEvenement()">
        <p-tabview styleClass="compact-tabs">
          <!-- Onglet Informations générales -->
          <p-tabpanel header="Informations générales">
            <div class="flex flex-col gap-3">
              <div class="flex flex-col">
                <label class="font-medium mb-1 text-sm">Utilisateur(s)*</label>
                <p-multiselect
                  [options]="allTechnicians"
                  optionLabel="fullName"
                  formControlName="users"
                  placeholder="Sélectionner les techniciens"
                  styleClass="w-full"
                ></p-multiselect>
              </div>

              <div class="flex flex-col">
                <label class="font-medium mb-1 text-sm"
                  >Type d'évènement*</label
                >
                <p-select
                  [options]="allEventTypes"
                  optionLabel="name"
                  formControlName="eventType"
                  styleClass="w-full"
                  [filter]="true"
                  (onChange)="setEventTypeName($event)"
                  appendTo="body"
                ></p-select>
              </div>

              <div class="flex flex-col">
                <label class="font-medium mb-1 text-sm">Nom*</label>
                <input type="text" pInputText formControlName="name" />
              </div>

              <div class="flex flex-col">
                <label class="font-medium mb-1 text-sm">Description</label>
                <textarea
                  pTextarea
                  rows="2"
                  placeholder="Facultatif : Description"
                  class="w-full"
                  formControlName="description"
                ></textarea>
              </div>

              <!-- Date/Time in row for space saving -->
              <div class="grid grid-cols-3 gap-2">
                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">Date et heure*</label>
                  <p-datepicker
                    [showTime]="true"
                    [showIcon]="true"
                    formControlName="startTime"
                    styleClass="w-full"
                    dateFormat="dd/mm/yy"
                    hourFormat="24"
                  ></p-datepicker>
                </div>

                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">Durée*</label>
                  <p-datepicker
                    formControlName="duration"
                    [timeOnly]="true"
                    styleClass="w-full"
                    hourFormat="24"
                    [showIcon]="true"
                  ></p-datepicker>
                </div>

                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">CP</label>
                  <input type="text" pInputText formControlName="postalCode" />
                </div>
              </div>

              <!-- Address fields in row -->
              <div class="grid grid-cols-2 gap-2">
                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">Adresse</label>
                  <input type="text" pInputText formControlName="address" />
                </div>
                <div class="flex flex-col">
                  <label class="font-medium mb-1 text-sm">Ville</label>
                  <input type="text" pInputText formControlName="locality" />
                </div>
              </div>
            </div>
          </p-tabpanel>

          <!-- Onglet Récurrence - Visible seulement si l'événement est récurrent -->
          <p-tabpanel *ngIf="isRecurrentEvent">
            <ng-template pTemplate="header">
              <span class="flex items-center gap-2">
                <i class="pi pi-refresh"></i>
                <span>Récurrence</span>
                <span
                  *ngIf="form.get('recurrenceEnabled')?.value"
                  class="bg-primary-500 text-white text-xs px-1.5 py-0.5 rounded-full"
                >
                  Activée
                </span>
              </span>
            </ng-template>

            <div class="flex flex-col gap-4">
              <!-- Message d'information pour les événements récurrents -->
              <div
                class="flex items-center gap-3 p-3 rounded-lg bg-blue-100 dark:bg-blue-900"
              >
                <i
                  class="pi pi-info-circle text-blue-600 dark:text-blue-300"
                ></i>
                <p class="text-sm text-blue-800 dark:text-blue-200">
                  Cet événement fait partie d'une série récurrente. Vous pourrez
                  choisir quelles occurrences modifier après validation.
                </p>
              </div>

              <!-- Configuration de la récurrence -->
              <div class="space-y-4">
                <!-- Intervalle de récurrence -->
                <div
                  class="border rounded-lg p-4 bg-primary-50 dark:bg-primary-900/20 border-primary-200 dark:border-primary-700"
                >
                  <h6
                    class="font-semibold text-sm mb-3 text-primary-800 dark:text-primary-200"
                  >
                    <i class="pi pi-clock mr-2"></i>
                    Fréquence
                  </h6>

                  <div class="flex items-center gap-3">
                    <span class="text-sm">Répéter tous les</span>
                    <p-inputNumber
                      [min]="1"
                      formControlName="recurrenceInterval"
                      [style]="{ width: '80px' }"
                    ></p-inputNumber>
                    <p-select
                      [options]="recurrenceUnits"
                      formControlName="recurrenceUnit"
                      placeholder="Unité"
                      optionLabel="label"
                      optionValue="value"
                      appendTo="body"
                      [style]="{ minWidth: '120px' }"
                    ></p-select>
                  </div>
                </div>

                <!-- Jours de la semaine -->
                <div
                  *ngIf="form.get('recurrenceUnit')?.value === 'week'"
                  class="border rounded-lg p-4 bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-700"
                >
                  <h6
                    class="font-semibold text-sm mb-3 text-blue-800 dark:text-blue-200"
                  >
                    <i class="pi pi-calendar mr-2"></i>
                    Jours de la semaine
                  </h6>

                  <div class="grid grid-cols-7 gap-2">
                    <p-toggle-button
                      *ngFor="let day of weekDays"
                      [onLabel]="day.label"
                      [offLabel]="day.label"
                      [(ngModel)]="day.selected"
                      (onChange)="toggleDay(day.value)"
                      [ngModelOptions]="{ standalone: true }"
                      styleClass="week-day-toggle"
                    >
                    </p-toggle-button>
                  </div>
                </div>

                <!-- Fin de récurrence -->
                <div
                  class="border rounded-lg p-4 bg-orange-50 dark:bg-orange-950/70 border-orange-200 dark:border-orange-500"
                >
                  <h6
                    class="font-semibold text-sm mb-3 text-orange-800 dark:text-orange-300"
                  >
                    <i class="pi pi-calendar-times mr-2"></i>
                    Fin de la récurrence
                  </h6>

                  <div class="space-y-3">
                    <div class="flex items-center gap-3">
                      <p-radiobutton
                        name="recurrenceEndType"
                        value="never"
                        formControlName="recurrenceEndType"
                        inputId="never"
                      ></p-radiobutton>
                      <label
                        for="never"
                        class="cursor-pointer text-gray-700 dark:text-gray-200"
                      >
                        Ne jamais finir
                      </label>
                    </div>

                    <div class="flex items-center gap-3">
                      <p-radiobutton
                        name="recurrenceEndType"
                        value="after"
                        formControlName="recurrenceEndType"
                        inputId="after"
                      ></p-radiobutton>
                      <label
                        for="after"
                        class="cursor-pointer text-gray-700 dark:text-gray-200"
                      >
                        Finir après
                      </label>
                      <p-inputnumber
                        *ngIf="form.get('recurrenceEndType')?.value === 'after'"
                        [min]="1"
                        formControlName="recurrenceEndAfter"
                        [style]="{ width: '80px' }"
                      ></p-inputnumber>
                      <span
                        *ngIf="form.get('recurrenceEndType')?.value === 'after'"
                        class="text-gray-700 dark:text-gray-200"
                      >
                        occurrences
                      </span>
                    </div>

                    <div class="flex items-center gap-3">
                      <p-radiobutton
                        name="recurrenceEndType"
                        value="until"
                        formControlName="recurrenceEndType"
                        inputId="until"
                      ></p-radiobutton>
                      <label
                        for="until"
                        class="cursor-pointer text-gray-700 dark:text-gray-200"
                      >
                        Finir le
                      </label>
                      <p-datepicker
                        *ngIf="form.get('recurrenceEndType')?.value === 'until'"
                        formControlName="recurrenceEndDate"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        appendTo="body"
                        placeholder="Date de fin"
                        [style]="{ width: '150px' }"
                      ></p-datepicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p-tabpanel>
        </p-tabview>

        <div
          class="flex justify-end pt-4 border-t border-surface-200 dark:border-surface-700 mt-4"
        >
          <button
            type="submit"
            pButton
            class="p-button-primary"
            [disabled]="submitting"
            [loading]="submitting"
          >
            <i class="pi pi-check mr-2" *ngIf="!submitting"></i>
            <span>{{
              submitting ? 'Modification en cours...' : 'Modifier l’événement'
            }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<!-- Dialogue personnalisé pour les options de modification récurrente -->
<p-dialog
  [(visible)]="showRecurrenceEditDialog"
  [modal]="true"
  header="Modification d'événement récurrent"
  [style]="{ width: '500px' }"
  (onHide)="closeRecurrenceEditDialog()"
>
  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-2 text-blue-500">
      <i class="pi pi-info-circle text-2xl"></i>
      <div>
        <p class="font-medium">
          Cet événement fait partie d'une série récurrente.
        </p>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          Quelles occurrences souhaitez-vous modifier ?
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-3">
      <button
        type="button"
        pButton
        label="Cette occurrence uniquement"
        icon="pi pi-calendar"
        class="p-button-outlined p-button-secondary w-full justify-start"
        (click)="selectEditScope('this')"
      ></button>

      <button
        type="button"
        pButton
        label="Celle-ci et les futures"
        icon="pi pi-calendar-plus"
        class="p-button-outlined p-button-info w-full justify-start"
        (click)="selectEditScope('thisAndFuture')"
      ></button>

      <button
        type="button"
        pButton
        label="Toutes les occurrences"
        icon="pi pi-calendar-times"
        class="p-button-outlined p-button-primary w-full justify-start"
        (click)="selectEditScope('all')"
      ></button>
    </div>

    <div class="flex justify-end pt-3 border-t">
      <button
        type="button"
        pButton
        label="Annuler"
        icon="pi pi-times"
        class="p-button-text"
        (click)="closeRecurrenceEditDialog()"
      ></button>
    </div>
  </div>
</p-dialog>
